let itemHtmlFc = null
let itemChatsFc = null

export function initChatsFc(chats) {
  itemChatsFc = chats
}

export function getChatsFc() {
  return itemChatsFc
}

export function initDataFc(htmlFc) {
  itemHtmlFc = htmlFc
}

export function getDataFc() {
  return itemHtmlFc
}